import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../resources/routes-constants'
import { Button } from '@mui/material'
import { AttachMoney } from '@mui/icons-material'

function scrollToElement() {
    const element = document.getElementById('donate')
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
    }
}

const TopNav: React.FC = () => {
    return (
        <div>
            <nav className="mainnav navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
                <div className="container-fluid flex-wrap">
                    <Link className="navbar-brand d-none d-sm-block" to={ROUTES.MAINPAGE_ROUTE}>
                        <span className="navbar-title">The House of Afros, Capes and Curls</span>
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarResponsive"
                        aria-controls="navbarResponsive"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        Menu
                        <i className="fas fa-bars ms-1" aria-hidden="true"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" to={ROUTES.MAINPAGE_ROUTE}>
                                    Home
                                </Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    to={ROUTES.ABOUT_ROUTE}
                                >
                                    About
                                </Link>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.ABOUT_ROUTE}>
                                            About The House
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.MEETTEAM_ROUTE}>
                                            Meet the Team
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    to={ROUTES.COMMUNITYENGAGEMENT_ROUTE}
                                >
                                    Community
                                </Link>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.COMMUNITYENGAGEMENT_ROUTE}>
                                            Engagement
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.EDUCATION_ROUTE}>
                                            Education
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={ROUTES.SPECIALEVENTS_ROUTE}
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Events
                                </Link>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.SPECIALEVENTS_ROUTE}>
                                            Event Calendar
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.SIGNATUREEVENTS_ROUTE}>
                                            Signature Events
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.JUNETEENTH_ROUTE}>
                                            Juneteenth
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to={ROUTES.BOOKCLUB_ROUTE}>
                                    Book Club
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={ROUTES.STORE_ROUTE} target="_blank" rel="noopener noreferrer">
                                    Tickets & Store
                                </a>
                            </li>
                        </ul>

                        <span className="d-flex donate-button-wrapper">
                            <Button
                                variant="contained"
                                endIcon={<AttachMoney />}
                                onClick={scrollToElement}
                                className="donate-button"
                                aria-label="Donate to HOACC"
                            >
                                Donate
                            </Button>
                        </span>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default TopNav
